import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { SpinnerComponent } from '@adaptiva/widgets/spinner';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OidcRedirectComponent } from './oidc-redirect.component';
import { OidcRegistrationRedirectComponent } from './oidc-registration-redirect';

@NgModule({
	imports: [
		AlertComponentModule,
		CommonModule,
		RouterModule.forChild([
			{
				path: '',
				component: OidcRedirectComponent
			},
			{
				path: 'registration',
				component: OidcRegistrationRedirectComponent
			}
		]),
		SpinnerComponent
	],
	declarations: [
		OidcRedirectComponent,
		OidcRegistrationRedirectComponent
	],
	exports: [
		OidcRedirectComponent,
		OidcRegistrationRedirectComponent
	]
})
export class OidcRedirectModule {

}
